import moment from 'moment';

export class CommentTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      subtype: obj.attributes.subtype,
      content: obj.attributes.content,
      data: obj.attributes.data,
      createdAt: obj.attributes.created_at
        ? moment(obj.attributes.created_at).toISOString()
        : null,
      // Can add more later as needed...
    };
  }
}
